// Constants
import { BOARD_SUMMARIES_LOAD, BOARD_SUMMARIES_LOAD_ELEMENTS, BOARD_SUMMARIES_REMOVE } from './boardSummariesConstants';

export const boardSummariesLoad = (boardSummaries) => ({ type: BOARD_SUMMARIES_LOAD, boardSummaries });
export const boardSummariesLoadElements = (elements) => ({ type: BOARD_SUMMARIES_LOAD_ELEMENTS, elements });
export const boardSummariesRemove = (boardIds) => ({ type: BOARD_SUMMARIES_REMOVE, boardIds });
